<template>
  <div class="table-container">
    <!-- <b-button
      variant="outline-primary"
      @click="handleAdd()"
      size="sm"
      class="new_row_btn"
      >Add a new row</b-button
    > -->
    <b-editable-table
      striped
      outlined
      head-variant="light"
      sticky-header
      hover
      small
      bordered
      responsive="sm"
      stacked="md"
      show-empty
      disableDefaultEdit
      :rowUpdate="rowUpdate"
      :editMode="'row'"
      class="editable-table"
      v-model="tableItems"
      :fields="fields"
    >
      <!-- :select-mode="select_mode"
      :filter="filter"
      :filter-included-fields="filter_included_fields"
      @filtered="$emit('onFiltered', $event)"
      selectable
      @row-selected="$emit('onRowSelected', $event)"
      ref="selectableTable" -->
      <!-- <template #cell(selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template> -->
      <template #cell(edit)="data">
        <div v-if="data.isEdit">
          <BIconX
            class="edit-icon"
            @click="() => handleSubmit(data, false)"
          ></BIconX>
          <BIconCheck
            class="edit-icon"
            @click="() => handleSubmit(data, true)"
          ></BIconCheck>
        </div>
        <BIconPencil
          v-else
          class="edit-icon"
          @click="handleEdit(data, true)"
        ></BIconPencil>
      </template>
      <!-- <template #cell(delete)="data">
        <BIconTrash
          class="remove-icon"
          @click="handleDelete(data)"
        ></BIconTrash>
      </template> -->
    </b-editable-table>
    <b-alert
      :show="alertTime"
      dismissible
      fade
      :variant="alertVariant"
      @dismiss-count-down="alertTimeChanged"
      >{{ alertMessage }}
    </b-alert>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "pinia";
import { useMetadataCatalog } from "@/store"; //useAuth
import BEditableTable from "bootstrap-vue-editable-table";
import {
  // BIconTrash,
  BIconPencil,
  BIconX,
  BIconCheck,
  // BButton,
} from "bootstrap-vue";

export default Vue.extend({
  // props: {
  //   id: {
  //     type: String,
  //     default: "data-table",
  //   },
  //   select_mode: {
  //     type: String,
  //     default: "",
  //   },
  //   filter: {
  //     type: String,
  //     default: "",
  //   },
  //   filter_included_fields: {
  //     type: Array,
  //     default: () => [],
  //   },
  // },
  components: {
    BEditableTable,
    BIconX,
    // BIconTrash,
    BIconPencil,
    BIconCheck,
    // BButton,
  },
  data() {
    return {
      fields: [],
      tableItems: [],
      rowUpdate: {},
      emptyRow: {},
      updateType: "",
      alertVariant: "success",
      alertTime: 0,
      alertMessage: null,
      dismissSecs: 4,
      // currentEditableFields: [],
      // validInsert: true,
    };
  },
  computed: {
    ...mapState(
      useMetadataCatalog,
      [
        "selectedCategory",
        "items",
        "columnNames",
        "meta",
        "editableFields",
        "selectedDataCatId",
        "updateLogId",
      ]
      // useAuth,
      // ["getUserInfo", "userGroup"]
    ),
  },
  mounted() {
    setTimeout(() => this.loadData(), 1000);
  },
  methods: {
    alertTimeChanged(alertTime) {
      this.alertTime = alertTime;
    },
    init() {
      this.fields = [];
      this.tableItems = [];
      this.rowUpdate = {};
      this.emptyRow = {};
      this.updateType = "";
      this.alertVariant = "success";
      this.alertTime = 0;
      this.alertMessage = null;
      this.dismissSecs = 4;
      // this.validInsert = true;
    },
    checkEditableFields(col) {
      switch (this.selectedCategory.id) {
        case "v_field_cat":
          return this.editableFields.field_cat.includes(col);
        case "v_data_cat":
          return this.editableFields.data_cat.includes(col);
        case "v_data_desc_cat":
          return this.editableFields.data_desc_cat.includes(col);
        default:
          return false;
      }
    },
    loadData() {
      // console.log("this is user info ", this.getUserInfo);
      //   this.fields.unshift("delete"); // puts data at the start of the queue
      this.init();
      // this.loadEditableFields();
      // if (this.meta.columns === undefined) {
      //   setTimeout(() => this.init(), 1000);
      // }
      // this.fields.push({ key: "delete", label: "", class: "delete-col" });
      this.fields.push({ key: "edit", label: "", class: "edit-col" });
      // console.log(
      //   "loadData this.editableFields ",
      //   this.editableFields.field_cat,
      //   this.currentEditableFields
      // );
      for (let col in this.meta?.columns) {
        this.fields.push({
          key: this.meta.columns[col]["columnName"],
          label: this.meta.columns[col]["columnName"],
          type:
            this.meta.columns[col]["type"] === "String"
              ? "text"
              : this.meta.columns[col]["type"] === "Integer"
              ? "number"
              : this.meta.columns[col]["type"] === "DateTime"
              ? "date"
              : this.meta.columns[col]["type"] === "Boolean"
              ? "checkbox"
              : this.meta.columns[col]["type"],
          editable: this.checkEditableFields(
            this.meta.columns[col]["columnName"]
          ),
        });
      }
      this.fields.push({ key: "id", label: "_ID" });
      this.tableItems = this.items.map((x, i) => ({
        ...x,
        id: i,
      }));
      // console.log("fields ", this.fields);
      // console.log("tableItems ", this.tableItems);
      // console.log("items ", this.items[0]);
      for (let i = 2; i < this.fields.length; i++) {
        if (
          [
            "is_critical_data",
            "is_primary_key",
            "is_spatial_field",
            "is_standard_field",
          ].includes(this.fields[i]["key"])
        ) {
          this.emptyRow[this.fields[i]["key"]] = false;
        } else this.emptyRow[this.fields[i]["key"]] = null;
      }
      // if (this.items[0] !== undefined) {
      //   for (let col in this.items[0]) {
      //     if (
      //       [
      //         "is_critical_data",
      //         "is_primary_key",
      //         "is_spatial_field",
      //         "is_standard_field",
      //       ].includes(col)
      //     ) {
      //       this.emptyRow[col] = false;
      //     } else this.emptyRow[col] = null;
      //   }
      // } else {
      //   for (let i = 2; i < this.fields.length; i++) {
      //     if (
      //       [
      //         "is_critical_data",
      //         "is_primary_key",
      //         "is_spatial_field",
      //         "is_standard_field",
      //       ].includes(this.fields[i]["key"])
      //     ) {
      //       this.emptyRow[this.fields[i]["key"]] = false;
      //     } else this.emptyRow[this.fields[i]["key"]] = null;
      //   }
      // }
    },
    changeUpdateType(action) {
      // console.log("changeUpdateType ", action);
      this.updateType = action;
    },
    // handleAdd() {
    //   // console.log("handleAdd ", this.tableItems.length);
    //   let newRow = this.emptyRow;
    //   newRow["id"] = this.tableItems.length;
    //   this.rowUpdate = {
    //     edit: true,
    //     id: newRow.id,
    //     action: "add",
    //     data: newRow,
    //   };
    //   this.changeUpdateType("addRow");
    // },
    handleSubmit(data, update) {
      // console.log("handleSubmit ", this.rowUpdate.data);
      // if (this.validateFields(data.item)) {
      this.rowUpdate = {
        edit: false,
        id: data.id,
        action: update ? "update" : "cancel",
      };
      // } else
      //   this.showAlert(4, "danger", "Please fill all the required fields!");
    },
    handleEdit(data) {
      if (!data.item.is_standard_field) {
        this.rowUpdate = { edit: true, id: data.id };
        this.changeUpdateType("updateRow");
      } else
        this.showAlert(
          4,
          "danger",
          "The selected record is a standard field, hence cannot be edited."
        );
    },
    handleDelete(data) {
      // console.log("this is delete code - data ", data);
      this.rowUpdate = { id: data.id, action: "delete" };
    },
    validateName(value) {
      if (value === "") {
        return {
          valid: false,
          errorMessage: "Please enter name",
        };
      }
      return { valid: true };
    },
    async updateDBEditedFields(newEdit, original) {
      let colsToBeUpdated = [];
      const idColumn = this.meta.catalogueInfo.idColumnName;

      for (let newCol in newEdit) {
        if (newCol !== "id")
          if (original[newCol] !== newEdit[newCol]) {
            colsToBeUpdated.push({
              column: {
                columnName: newCol,
              },
              value: newEdit[newCol],
            });
          }
      }
      const postResponse = await useMetadataCatalog().updateMetadata({
        catalogUri: this.selectedCategory.uri,
        request: {
          columnUpdates: colsToBeUpdated,
          filter: [
            {
              fieldName: idColumn,
              filterOperator: 0,
              conditionOperator: 0,
              value: newEdit[idColumn],
            },
          ],
        },
      });
      if (postResponse) {
        if (postResponse === 200) {
          this.showAlert(this.dismissSecs, "success", "Successfully updated!");
        } else {
          this.showAlert(
            4,
            "danger",
            "Something is wrong! Status code " + postResponse
          );
        }
      } else {
        this.showAlert(4, "danger", "Something is wrong! Empty response!");
      }
    },
    async addNewRowDB(newRow) {
      let colsToBeInserted = [];
      colsToBeInserted.push({
        column: {
          columnName: "data_cat_id",
        },
        value: this.selectedDataCatId,
      });
      let catName = this.selectedCategory.id.substring(2);
      for (let col in this.editableFields[catName]) {
        if (newRow[this.editableFields[catName][col]] !== null) {
          colsToBeInserted.push({
            column: {
              columnName: this.editableFields[catName][col],
            },
            value: newRow[this.editableFields[catName][col]],
          });
        }
      }
      colsToBeInserted.push({
        column: {
          columnName: "update_log_id",
        },
        value: this.updateLogId,
      });

      const response = await useMetadataCatalog().insertMetadata({
        catalogUri: this.selectedCategory.uri,
        request: {
          columnInserts: colsToBeInserted,
        },
      });
      if (response) {
        if (response === 200) {
          this.showAlert(this.dismissSecs, "success", "Successfully updated!");
        } else {
          this.showAlert(
            this.dismissSecs,
            "danger",
            "Something is wrong! Status code " + response
          );
        }
      } else {
        this.showAlert(
          this.dismissSecs,
          "danger",
          "Something is wrong! Empty response!"
        );
      }

      this.$emit("reloadData");
      setTimeout(() => this.loadData(), 1000);
    },
    showAlert(time, variant, msg) {
      this.alertTime = time;
      this.alertVariant = variant;
      this.alertMessage = msg;
    },
    validateFields(val) {
      // console.log("val[field_name] ", val["field_name"]);
      if (val["field_name"] !== null) {
        this.validInsert = true;
        return true;
      } else {
        this.validInsert = false;
        return false;
      }
      // for (let col in this.editableFields) {
      //   console.log(this.editableFields[col]);
      //   if (val[this.editableFields[col]] === null) {
      //     this.showAlert(4, "danger", "Please fill all the required fields!");
      //     this.validInsert = false;
      //     return false;
      //   }
      // }
      // this.validInsert = true;
      // return true;
    },
    // callOnFiltered() {
    //   this.$emit("onFiltered");
    // },
  },
  watch: {
    tableItems: {
      handler(val) {
        if (this.rowUpdate.id == undefined) return;
        const edited = val[this.rowUpdate.id];
        let checkField = "";
        switch (this.selectedCategory.id) {
          case "v_field_cat":
            checkField = "field_name";
            break;
          case "v_data_cat":
            checkField = "dataset_name";
            break;
          case "v_data_desc_cat":
            checkField = "high_level_desc";
            break;
          default:
            break;
        }
        // Object.keys(edited).forEach((x) => console.log(edited[x]));
        // const original = this.items[this.rowUpdate.id];
        switch (this.updateType) {
          case "updateRow":
            this.updateDBEditedFields(edited, this.items[this.rowUpdate.id]);
            break;
          case "addRow":
            // if (this.validateFields(val[0])) {
            // console.log("this is handler watch ", this.selectedCategory);
            if (val[0][checkField] !== null) {
              this.addNewRowDB(val[0]);
            }
            break;
          default:
            this.showAlert(
              4,
              "danger",
              "The data update type does not match! - " + this.updateType
            );
        }
      },
    },
  },
});
</script>

<style>
.table-container input {
  font-size: 13px !important;
}
.remove-icon {
  color: red;
  cursor: pointer;
  font-size: 18px;
}
.edit-icon {
  color: rgb(4, 83, 158);
  cursor: pointer;
  font-size: 18px;
}
table.b-table td {
  padding: 0.3rem !important;
  vertical-align: middle;
}
.delete-col {
  min-width: 30px !important;
}
.edit-col {
  min-width: 30px !important;
}
.new_row_btn {
  margin-bottom: 10px;
}
</style>
